import React from 'react'
import { NavLink } from 'react-router-dom'
import { orderBy } from 'lodash'

import { getRoutes, hasAccessToThis } from 'services/Utilities'
import { Badge, Dropdown } from 'ui'
import { t } from 'translations'

const AdminNav = ({ pathname }) => {
  const sortedRoutes = getRoutes('administration')

  // Sort routes into their corresponding groups
  let sections = []
  let groups = {}
  for (const route of sortedRoutes) {
    if (!route.title || (route.permission && !hasAccessToThis(route.permission))) continue

    if (route.group) {
      if (!groups[route.group]) groups[route.group] = { group: true, title: route.group, routes: [] }
      groups[route.group].routes.push(route)
    } else {
      sections.push(route)
    }
  }

  // Add all the groups at the end of the sections object
  sections.push(...Object.values(groups))

  const AdminLink = ({ route, inDropdown }) => {
    const isActive = !(route.dontMatch || []).reduce((acc, dontMatch) => (acc ? true : pathname.includes(dontMatch)), false) && pathname.includes(route.path)

    const RouteContent = (
      <>
        <span className="pr-1">
          <i className={`fad fa-${route.icon}`} />
        </span>{' '}
        <span className={inDropdown ? '' : 'd-none d-lg-inline'}>{t(`administration.${route.title}`)}</span>
        {route.isAlpha ? (
          <Badge variant="danger" className="ml-1">
            Alpha
          </Badge>
        ) : null}
        {route.isBeta ? (
          <Badge variant="danger" className="ml-1">
            Beta
          </Badge>
        ) : null}
        {route.isMeringo ? (
          <Badge variant="info" className="ml-1">
            Meringo
          </Badge>
        ) : null}
      </>
    )

    if (!inDropdown)
      return (
        <NavLink className={`nav-link${isActive ? ' active' : ''}`} to={route.path}>
          {RouteContent}
        </NavLink>
      )
    return (
      <Dropdown.Link to={route.path} className={`${isActive ? ' active' : ''}`}>
        {RouteContent}
      </Dropdown.Link>
    )
  }

  return (
    <nav className="navbar navbar-light navbar-expand-sm bg-white d-none d-md-block p-0" style={{ borderBottom: '1px solid #dfdfdf' }}>
      <ul className="navbar-nav px-2">
        {orderBy(sections, ['isMeringo'], ['desc']).map(section => {
          if (!section.group) return <AdminLink route={section} key={section.title} />

          return (
            <Dropdown className="nav-item" key={section.title}>
              <Dropdown.Toggle className="nav-link">{t(`administration.groupNames.${section.title}`)}</Dropdown.Toggle>
              <Dropdown.Menu aria-labelledby="navbarDropdown" direction="left">
                {section.routes.map(route => {
                  return <AdminLink route={route} key={route.title} inDropdown />
                })}
              </Dropdown.Menu>
            </Dropdown>
          )
        })}
      </ul>
    </nav>
  )
}

export default AdminNav
